module.exports = __webpack_public_path__ + "static/media/text_editor.24d202e9.webp";